import { render, staticRenderFns } from "./item-rent.vue?vue&type=template&id=6f7a0f9a&scoped=true&"
import script from "./item-rent.vue?vue&type=script&lang=js&"
export * from "./item-rent.vue?vue&type=script&lang=js&"
import style0 from "./item-rent.vue?vue&type=style&index=0&id=6f7a0f9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a0f9a",
  null
  
)

export default component.exports